import React from "react";

import sortedIcon from "../../assets/images/png/sortedIcon.png";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import { memo } from "react";
import { useEffect } from "react";
import SortingHook from "../../utils/Hooks/SortingHook";

const UnrealisedTable = ({
  instrumentsData,
  columns,
  rowData,
  order,
  setOrder,
}) => {
  const { isAscending, keyToSort, arrData, setKeyForOrdering } = SortingHook(
    instrumentsData,
    order.key,
    order.order,
  );

  const headerRenderer = (
    { label, key, classn, width, sortable },
    rowData,
    index,
  ) => {
    return (
      <th
        aria-sort={
          keyToSort === key
            ? isAscending
              ? "Ascending"
              : "Descending"
            : undefined
        }
        className={classn && classn}
        style={{ width: width }}
      >
        {sortable ? (
          <button
            className="header_cell"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setKeyForOrdering(key, keyToSort === key ? !isAscending : false);
              setOrder({
                key: key,
                order: order.key === key ? !isAscending : false,
                id: order.id,
              });
            }}
          >
            <p>{label}</p>
            {sortable && (
              <>
                <div className="accordion_table_header_child_icon">
                  <img
                    src={
                      !isAscending && keyToSort === key
                        ? sortedAtoz
                        : isAscending && keyToSort === key
                          ? sortedIcon
                          : keyToSort !== key
                            ? unsortedIcon
                            : ""
                    }
                    alt="sort"
                  />
                </div>
              </>
            )}
          </button>
        ) : (
          <div
            className="header_cell"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setKeyForOrdering(key, keyToSort === key ? !isAscending : false);
              setOrder({
                key: key,
                order: order.key === key ? !isAscending : false,
                id: order.id,
              });
            }}
          >
            <p>{label}</p>
          </div>
        )}
      </th>
    );
  };

  useEffect(() => {
    setKeyForOrdering(order.key, order.order);
  }, [instrumentsData, order]);

  return (
    <>
      <table className="table accordion_content_custom_table ">
        <thead>
          <tr>
            {columns?.map((item) => {
              return headerRenderer(item, rowData);
            })}
          </tr>
        </thead>
        <tbody className="unrealised_report_table">
          {arrData?.map((eachVehicle) => {
            return (
              <tr>
                {columns.map((eachColumn) => {
                  return (
                    <td style={{ padding: "14px 0" }}>
                      {eachColumn?.cellRenderer
                        ? eachColumn?.cellRenderer(
                            eachVehicle,
                            eachColumn.key,
                            rowData,
                          )
                        : JSON.stringify(eachVehicle[eachColumn.key])}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default memo(UnrealisedTable);
